import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

import lightLogo from '../../assets/logo-light.png';
import lightLogo2x from '../../assets/logo-light@2x.png';

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
  }, [menuOpen]);

  const handleToggleMenu = () => setMenuOpen((open) => !open);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary sticky-top">
      <div className="container d-flex align-items-center justify-content-between">
        {/* Brand */}
        <Link
          className="navbar-brand d-flex align-items-center"
          to="/"
          onClick={closeMenu}
        >
          <img
            src={lightLogo}
            srcSet={`${lightLogo2x} 2x`}
            alt="TrophyTracker Logo"
            height="30"
            className={'logo-img d-inline-block align-text-top'}
          />
        </Link>

        {/* Right side buttons */}
        <div className="d-flex align-items-center gap-2">
          {/* Burger toggle */}
          <button
            className="btn btn-lg border-0 rounded-sm d-lg-none menu-toggle"
            type="button"
            onClick={handleToggleMenu}
            aria-label="Toggle navigation"
          >
            <i className="bi bi-list"></i>
          </button>
        </div>

        {/* Desktop nav-links */}
        <div className="collapse navbar-collapse d-none d-lg-flex justify-content-between">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink className="nav-link" to="/search">
                Search
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/location">
                Location
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/retired">
                Retired
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/submit">
                Submit
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/contact">
                Contact
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/stats">
                Stats
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/welshweekender">
                TWW
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

      {/* Mobile menu overlay */}
      <div
        className={`mobile-menu d-flex flex-column justify-content-start gap-5 ${
          menuOpen ? 'open' : ''
        }`}
      >
        <div className="d-flex flex-row justify-content-end">
          <button
            className="btn btn-lg btn-close"
            type="button"
            onClick={handleToggleMenu}
            aria-label="Toggle navigation"
          ></button>
        </div>
        <ul className="navbar-nav text-center mx-auto px-3">
          <li>
            <Link
              className="navbar-brand d-flex align-items-center"
              to="/"
              onClick={closeMenu}
            >
              <img
                src={lightLogo}
                srcSet={`${lightLogo2x} 2x`}
                alt="TrophyTracker Logo"
                className={'logo-img d-inline-block align-text-top'}
              />
            </Link>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/search" onClick={closeMenu}>
              Search
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/location" onClick={closeMenu}>
              Location
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/retired" onClick={closeMenu}>
              Retired
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/submit" onClick={closeMenu}>
              Submit
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/contact" onClick={closeMenu}>
              Contact
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/stats" onClick={closeMenu}>
              Stats
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/welshweekender"
              onClick={closeMenu}
            >
              TWW
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Backdrop Overlay */}
      {menuOpen && <div className="menu-backdrop" onClick={closeMenu}></div>}
    </nav>
  );
};

export default NavBar;
